import React from 'react';

const RecomendedIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#ECF0F1"/>
      <path d="M15 7.5C10.8643 7.5 7.5 10.8643 7.5 15C7.5 19.1357 10.8643 22.5 15 22.5C19.1357 22.5
      22.5 19.1357 22.5 15C22.5 10.8643 19.1357 7.5 15 7.5ZM15 8.75C18.4595 8.75 21.25 11.5405
      21.25 15C21.25 18.4595 18.4595 21.25 15 21.25C11.5405 21.25 8.75 18.4595 8.75 15C8.75
      11.5405 11.5405 8.75 15 8.75ZM15 11.25C13.6255 11.25 12.5 12.3755 12.5 13.75H13.75C13.75
      13.0518 14.3018 12.5 15 12.5C15.6982 12.5 16.25 13.0518 16.25 13.75C16.25 14.2285 15.9424
      14.6533 15.4883 14.8047L15.2344 14.8828C14.7241 15.0513 14.375 15.5396 14.375
      16.0742V16.875H15.625V16.0742L15.8789 15.9961C16.8408 15.6763 17.5 14.7632 17.5
      13.75C17.5 12.3755 16.3745 11.25 15 11.25ZM14.375 17.5V18.75H15.625V17.5H14.375Z"
      fill="#999999"/>
    </svg>
  );
};

export default RecomendedIcon;
